import { graphql } from 'react-apollo'
import Venue       from '/models/venue'

#
# Queries
#

import index        from './queries/index.gql'
import ticketmasterVenues from './queries/ticketmaster_venues.gql'

export withVenues = graphql index,
  options: (props)->
    { page, search } = props.location.state or {}
    variables:
      page: page or 1
      search: search or undefined
  props: ({props, data})->
    { nodes, pagination } = data.venues or {}
    venues: Venue.parse nodes or []
    venuesPagination: pagination
    venuesLoading: data.loading
    venuesRefetch: data.refetch

export withTicketmasterVenues = graphql ticketmasterVenues,
  options: (props)->
    { venue_search } = props.location.state or {}
    variables:
      search: venue_search
  props: ({props, data})->
    ticketmaster_venues: Models.Venue.parse data.ticketmaster_venues or []
    ticketmaster_venuesLoading: data.loading

#
# Mutations
#

import createVenue from '/mutations/venues/create.gql'
import updateVenue from '/mutations/venues/update.gql'

export withCreateVenue = graphql createVenue,
  props: ({ mutate })->
    createVenue: (attrs)->
      {data: {venue_create: {venue, errors}}} = \
      await mutate variables: venue: attrs
      {venue, errors}

export withUpdateVenue = graphql updateVenue,
  props: ({ mutate })->
    updateVenue: (id, attrs)->
      {data: {venue_update: {venue, errors}}} = \
      await mutate variables: {id: id, venue: attrs}
      {venue, errors}
